import TrainingLevel from './TrainingLevel';

export default TrainingLevel;
